RegExp.escape = function(this: RegExp, text: string): string {
    return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
}

String.prototype.mapReplace = function (
    this: string, 
    replacements: {
        [key: string]: string
    }
): string {
    var regexTokens = [];

    for (var prop in replacements) {
        regexTokens.push(RegExp.escape(prop) as never);
    }

    let regex = new RegExp(regexTokens.join('|'), "g");

    if (regexTokens.length) {
        return this.replace(regex, function(match) {
            return replacements[match];
        });
    }
    return this;
}